







































import Vue from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { namespace } from 'vuex-class';

import Field from '@/shared/components/Field/Field.vue';
import Input from '@/shared/components/Inputs/Input.vue';
import Button from '@/shared/components/Button/Button.vue';
import { sendInteractEvent } from '@/helpers/events';

import { EPaymentMethodTypes } from '@/helpers/enums';

import { ICheckoutCartOfferCoupon, ICheckoutCartOffer } from '@/interfaces/Checkout';
import { EInteractEventTrackerAction } from '@/app/features/InteractEventTracker/enums/EInteractEventTracker';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    Field,
    Input,
    Button
  }
})
export default class ApplyCoupon extends Vue {
  @Prop({ default: () => false })
  private showApply!: boolean;

  @Prop({ default: () => '' })
  private coupon!: string;

  @AppModule.Action
  private prepareCheckout: Function;

  @AppModule.State
  private cardFirstDigitsSelected: string | number | null;

  @AppModule.State
  private paymentMethodSelected: string;

  @CheckoutModule.Mutation
  private setSelectedOfferCoupon: Function;

  @CheckoutModule.Getter
  private rootOffer: ICheckoutCartOffer;

  @CheckoutModule.Getter
  private selectedOffer: ICheckoutCartOffer;

  @CheckoutModule.Getter
  private bankSlipAcceptedTermsChecked!: boolean;

  @CheckoutModule.State
  private enableHiddenMethods: boolean;

  private validator = new Validator();
  private apply: boolean = false;

  private form = {
    fields: {
      coupon: ''
    },
    states: {
      loading: false
    },
    errors: this.validator.errors
  };

  private showApplyCoupon() {
    this.apply = true;

    sendInteractEvent({ action: EInteractEventTrackerAction.CHK_CUPOM_SHOW });
  }

  private async validateForm() {
    const isValid = await this.validator.validateAll({
      coupon: this.form.fields.coupon
    });
    if (isValid) return;
    throw isValid;
  }

  private get localCoupon () {
    return this.form.fields.coupon;
  }

  private get isMobile (): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private async submitForm() {
    this.form.states.loading = true;

    sendInteractEvent({ action: EInteractEventTrackerAction.CHK_CUPOM_SUBMIT });

    try {
      await this.validateForm();

      this.setSelectedOfferCoupon(this.localCoupon);

      await this.prepareCheckout({
        slug: this.rootOffer.slug,
        payload: {
          coupon: this.localCoupon ? this.localCoupon : null,
          payment_method: this.paymentMethodSelected,
          ...(this.cardFirstDigitsSelected && this.paymentMethodSelected === EPaymentMethodTypes.creditCard && {
            card_first_digits: this.cardFirstDigitsSelected,
          }),
          ...(this.bankSlipAcceptedTermsChecked && {
            is_payment_in_installments: this.bankSlipAcceptedTermsChecked,
            is_terms_accepted: this.bankSlipAcceptedTermsChecked,
          })
        },
        ...(this.enableHiddenMethods) && {
          enableHiddenMethods: this.enableHiddenMethods,
        }
      });
    } catch (error) {
      const msg = this.$t('App.Checkout.Offer.Coupon.Errors.generic') as string;
      this.form.errors.add({ field: 'coupon', msg });
    } finally {
      this.form.states.loading = false;
    }
  }

  private created() {
    this.validator.attach({
      name: 'coupon',
      rules: 'required'
    });
  }

  private destroyed() {
    this.validator.reset();
  }

  private mounted () {
    this.apply = this.showApply;
    this.form.fields.coupon = this.coupon;
  }
}
